import React from 'react';
import Hero from './components/left-out-practical/Hero';
import Main from './components/left-out-practical/Main';

const LeftOutPractical = () => {
    return (
        <div>
            <Hero />
            <Main />
        </div>
    )
}

export default LeftOutPractical;